import { ChangeDetectionStrategy, Component, Inject, NgModule } from '@angular/core';
import { MODAL_DATA } from '../../../shared/tokens/modal-data.token';
import { LevelSelectionType } from '../../../shared/types/level-selection-type';
import { LevelSelectionIframeModule } from '../level-selection-iframe/level-selection-iframe.component';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'lp2-change-level-modal',
  template: '<lp2-level-selection-iframe [levelSelectionType]="levelSelectionType"></lp2-level-selection-iframe>',
  styleUrls: ['./change-level-modal.component.scss'],
})
export class ChangeLevelModalComponent {
  public levelSelectionType: LevelSelectionType;

  constructor(
    @Inject(MODAL_DATA) private data: { levelSelectionType: LevelSelectionType },
  ) {
    this.levelSelectionType = this.data.levelSelectionType;
  }
}

@NgModule({
  imports: [LevelSelectionIframeModule, SharedModule],
  declarations: [ChangeLevelModalComponent],
  exports: [ChangeLevelModalComponent],
})
export class ChangeLevelModalModule {}


// WEBPACK FOOTER //
// ./ts/app/home/level-selection/change-level-modal/change-level-modal.component.ts